import styled from "@emotion/styled";
import { useFormContext } from "react-hook-form";
import { baseUrl, translate } from "@kaltura/mediaspace-shared-utils";
import { NameField, RichtextField, TagsField } from "@kaltura/mediaspace-shared-ui";
import { KeyboardEventHandler } from "react";

const StyledForm = styled("form")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}));

export interface CreateDraftEntryFormProps {
    formId: string;
    onSubmit: (data: { [key: string]: string | boolean }) => void;
    tagsSearchUrl: string;
}

/**
 * create draft entry form component, used in create draft entry modal
 */
export const CreateDraftEntryForm = ({ formId, onSubmit, tagsSearchUrl }: CreateDraftEntryFormProps) => {
    const { handleSubmit } = useFormContext();

    const stopKeyPropagation: KeyboardEventHandler<HTMLFormElement> = (e) => {
        if (e.key !== "Escape") {
            e.stopPropagation();
        }
    };

    return (
        <StyledForm id={formId} onSubmit={handleSubmit(onSubmit)} onKeyDown={stopKeyPropagation}>
            <NameField />
            <RichtextField
                label={translate("Description")}
                id={"description"}
                fontWeightBold={true}
                inline={true}
                minInputHeight={140}
            />
            <TagsField label={translate("Tags")} id={"tags"} url={`${baseUrl}${tagsSearchUrl}`} fontWeightBold={true} />
        </StyledForm>
    );
};
